export default "__VITE_ASSET__0349c977__"